import './plugins/axios'
import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import '@/assets/import.js'
import '@/assets/css/tailwind.css'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { createHead } from "@vueuse/head"
import { vue3Debounce } from 'vue-debounce'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import VueCountdown from '@chenfengyuan/vue-countdown';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faStar as faEmptyStar } from '@fortawesome/free-regular-svg-icons';
import { faSearch, faBars, faBell, faHome, faUsers, faChevronDown, faLink, faUser, faCopy, faChevronLeft, faSun, faMoon, faUniversalAccess, faSync, faEdit, faTrash, faEye, faStore, faTruck, faTimes, faBoxes, faClipboard } from '@fortawesome/free-solid-svg-icons';
import { faTelegram, faAtlassian, faTwitter, faFacebook, faWhatsapp, faInstagram } from '@fortawesome/free-brands-svg-icons';

library.add(
    faTrash,
    faLink,
    faUser,
    faCopy,
    faClipboard,
    faTimes,
    faBoxes,
    faTruck,
    faStore,
    faEdit,
    faEye,
    faEmptyStar,
    faSync,
    faUniversalAccess,
    faSun,
    faMoon,
    faChevronDown,
    faChevronLeft,
    faSearch,
    faUsers,
    faHome,
    faBell,
    faBars,
    faTelegram,
    faAtlassian,
    faTwitter,
    faFacebook,
    faWhatsapp,
    faInstagram,
)


const SweetAlert = {
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ff7674',
};

const debounceConfig = {
    lock: true,
    listenTo: 'keyup',
    defaultTime: '500ms',
    fireOnEmpty: false,
    trim: false
}

const dateTimeConfig = {
    name: 'CustomDatePicker',
    props: {
        format: 'YYYY-MM-DD',
        displayFormat: 'jYYYY-jMM-jDD',
        editable: false,
        inputClass: 'form-control text-white dark:bg-gray-700 border-gray-300 dark:border-gray-700 bg-gray-50 my-custom-class-name',
        placeholder: '',
        altFormat: 'YYYY-MM-DD',
        color: '#3e46ff',
        autoSubmit: true,
    }
}

const app = createApp(App)
const head = createHead()

app.component('QuillEditor', QuillEditor)
app.component('DatePicker', Vue3PersianDatetimePicker)
app.component(VueCountdown.name, VueCountdown);
app.component('font-awesome-icon', FontAwesomeIcon)


app.use(store)
    .use(router)
    .use(Toast)
    .use(VueSweetalert2, SweetAlert)
    .use(head)
    .use(Vue3PersianDatetimePicker, dateTimeConfig)
    .directive('debounce', vue3Debounce(debounceConfig))
    .mount('#app')
